import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {LanguageType} from '../shared/types';

const DESCRIPTION_HEBREW: string[] = [
  `כשהשמש מתחילה לרדת על משעולי פארק הירקון מתחילות לעלות היללות. זוהי שירת התנים הזהובים המקבלים את פניו של הירח המסמל את תחילתו של עוד יום בחייהם העירוניים, המלאים בהרפתקאות בפארק גני יהושע וברחובות הסמוכים.`,
  `התנים שפושטים מדי ערב על שבילי הפארק שבו לעיר אחרי גלות ארוכה, והם לומדים מחדש כיצד לחיות איתנו. העינים שלהם נוצצות מבין הצמחיה הנמוכה כשהם מביטים בנו מביטים בהם. הם סקרנים. גם אנחנו. המצרים הקדמוניים, שהתגוררו בגבעות אלו ממש, המליכו אותם לאלים ונתנו לאנוביס, אל התן, ללוות את המתים בדרכם האחרונה. אנחנו עדיין מנסים להבין איך לחיות איתם.`,
  `הפארק מלא בחיות — חלקן יחזרו איתנו הביתה, מחלק נהנה בעודנו בפארק ומאחרות ננסה להמנע. החיות הסיננתרופיות מתגוררות לצד האדם ומשגשגות מעצם הקרבה אליו. הן נהנות מקיומנו, חיות מהזבל שלנו, מתרוצצות בגינות ובצידי הדרכים, מתגוררות על צמרות העצים ובצינורות הביוב. הן אוהבות לחיות לצידנו, גם אם אנחנו לא תמיד אוהבים לחיות לצידם.`,
  `הצעידה בעקבות התנים ביללות זהובות מזכירה לנו שלא צריך להתרחק מהעיר כדי להתקל בטבע הפראי שעוטף אותנו ממש כאן, ושגבולות העיר, בדומה לגבולות החיבה שלנו, הם גבולות מלאכותיים בלבד. לא אמיתיים יותר מהאגם שנפרש לפנינו, לא מציאותיים יותר מהתמונה שמתגלה על המסך שלפנינו.`
];

const DESCRIPTION_ENGLISH: string[] = [
  `As the sun goes down on the paths running through HaYarkon Park, the howling begins. It is the song of the golden jackals, greeting the moon that marks the
beginning of another day in their urban life, a life full of adventures, in the park and in the nearby streets.`,
  `The jackals, who roam the park trails every evening, have returned to the city after a long exile, learning anew how to live with us. Their eyes sparkle from
amidst the low-lying vegetation as they look at us looking at them. They are curious. So are we. The ancient Egyptians, who lived in these very hills, deemed them gods and let Anubis, the jackal-headed human-bodied deity, accompany the dead on their final journey. We are still trying to figure out how to live with them.
`,
  `The park is full of life—some animals live with us in our homes, others charm us outdoors, and yet others we try to avoid. Synanthropic animals live and thrive alongside humans. They enjoy our existence, feed on our trash, dwell in parks and sidewalks, live on the treetops and in the sewer drains. They love living
with us, even if this love is not mutual.
`,
  `Walking in the footsteps of the jackals in Golden Howls reminds us that one does not have to go out of the city to encounter wild nature, which surrounds us right here. It indicates that the city limits, like the limits of our affection, are purely artificial; they are just as real as the lake unfolding before us, just as
realistic as the image revealed to us on screen.
`
];

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit {
  /** Language to use in the welcome page. */
  @Input() language: LanguageType = 'hebrew';

  description = DESCRIPTION_HEBREW;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.description = this.language === 'hebrew' ? DESCRIPTION_HEBREW : DESCRIPTION_ENGLISH;
  }

}
